import React, { useState } from "react";
import { useTranslation } from "react-i18next";
import useJumboAuth from "@jumbo/hooks/useJumboAuth";
import Div from "@jumbo/shared/Div/Div";
import { Grid, Stack, Typography, Link } from "@mui/material";
import JumboCardQuick from "@jumbo/components/JumboCardQuick/JumboCardQuick";
import JumboListNoDataPlaceholder from "@jumbo/components/JumboList/components/JumboListNoDataPlaceHolder/JumboListNoDataPlaceholder";
import DsokWidgets from "app/pages/home/dsok/widgets";

/**
 * Existing dashboard for customer_type=3. Unchanged behavior and output.
 */
const CustomerDashboard = () => {
  const { t } = useTranslation();
  const { getAuthUser } = useJumboAuth();
  const { customer } = getAuthUser() || {};
  const [widgets] = useState({});
  const superadmin = customer?.customerType === 1;
  const isDsok = customer?.dsok === true;
  const widgetList = widgets?.widgets || {
    support: true,
    news: true,
  };

  return (
    <Div>
      <Grid container spacing={2} alignItems="stretch">
        <Grid item xs={12}>
          <Typography variant="h2">{t("pages.home.header")}</Typography>
        </Grid>
        {widgetList.news && !isDsok && (
          <Grid item xs={12} md={8}>
            <JumboCardQuick
              title={
                <Typography variant="h2">
                  {t("sidebar.menuItem.news")}
                </Typography>
              }
              headerSx={{ mb: 0, pb: 0 }}
              sx={{ height: "100%" }}
            >
              <Stack>
                <JumboListNoDataPlaceholder width={{ md: 120, xs: 180 }} />
              </Stack>
            </JumboCardQuick>
          </Grid>
        )}
        {widgetList.support && !isDsok && (
          <Grid item xs={12} md={4} lg={3}>
            <JumboCardQuick
              title={
                <Typography variant="h2">{t("pages.home.contacts")}</Typography>
              }
              headerSx={{ mb: 0, pb: 0 }}
              sx={{ height: "100%" }}
            >
              <Stack spacing={4}>
                <Stack key="sk">
                  <Typography variant="h5">intesso s.r.o.</Typography>
                  <Link href="mailto:info@datavision.sk">
                    <Typography variant="body">info@datavision.sk</Typography>
                  </Link>
                  <Link href="phone:+421918755096">
                    <Typography variant="body">+421 918 755 096</Typography>
                  </Link>
                </Stack>
                <Stack>
                  {superadmin && (
                    <Link href="https://jenkins.gastrokiosk.online/job/Datavision Reverse SSH/lastSuccessfulBuild/artifact/*zip*/archive.zip">
                      <Typography variant="body">
                        {t("pages.home.downloadReverseSSH")}
                      </Typography>
                    </Link>
                  )}
                  <>
                    <Link href="https://login.datavision-online.eu/uploads/datavision-app/datavision_win_app.zip">
                      <Typography variant="body">
                        {t("pages.home.downloadApp")}
                      </Typography>
                    </Link>
                    <Link href="https://datavision-online.eu/wp-content/uploads/dsok/dsok-local-agent.zip">
                      <Typography variant="body">
                        {t("pages.home.downloadDsokLocalAgent")}
                      </Typography>
                    </Link>
                  </>
                </Stack>
              </Stack>
            </JumboCardQuick>
          </Grid>
        )}
        {isDsok && <DsokWidgets />}
      </Grid>
    </Div>
  );
};

export default CustomerDashboard;
